import clsx from 'clsx';
import { injuries } from '@/lib/constants';
import type { FieldErrors } from 'react-hook-form';
import type { ChangeEvent } from 'react';
import { LeadInput } from '@jlg-website/shared';

type InjuryRadioProps = {
  labelButtonBase: string;
  labelButtonClass: string;
  errorClasses: string;
  errors?: FieldErrors<LeadInput>;
  disabled?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

export function InjuryRadio({
  labelButtonBase,
  labelButtonClass,
  errorClasses,
  errors,
  disabled,
  onChange,
}: InjuryRadioProps) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {injuries.map((item) => {
        return (
          <label
            key={`input-injury-${item.value}`}
            className={clsx(
              labelButtonBase,
              labelButtonClass,
              errors?.lead?.answers?.[1] && errorClasses
            )}
          >
            {item.icon}
            <span>{item.label}</span>
            <input
              name="help"
              type="radio"
              value={item.value}
              className="sr-only"
              disabled={disabled}
              onChange={onChange}
            />
          </label>
        );
      })}
    </div>
  );
}
